var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 54,
    viewBox: "0 0 89 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.5973 52.3596C56.2555 53.2482 56.734 53.9317 57.691 53.9317H74.848C75.8049 53.9317 76.7619 53.1798 77.0353 52.2912L88.929 22.1469C89.2024 21.2582 88.6556 20.5063 87.767 20.5063H70.8834C69.9264 20.5063 68.9011 21.1899 68.5594 22.0785L56.5973 52.3596Z",
    fill: "#00754B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4025 52.3596C32.7442 53.2482 32.2657 53.9317 31.3088 53.9317H14.1518C13.1948 53.9317 12.2379 53.1798 11.9644 52.2912L0.0707359 22.1469C-0.202682 21.2582 0.344158 20.5063 1.23277 20.5063H18.1163C19.0733 20.5063 20.0986 21.1899 20.4404 22.0785L32.4025 52.3596Z",
    fill: "#00754B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9874 52.3596C39.6457 53.2482 40.1241 53.9318 41.0811 53.9318H58.2381C59.1951 53.9318 60.152 53.1799 60.4255 52.2913L80.5217 1.64051C80.7951 0.7519 80.2483 0 79.3597 0H62.4761C61.5191 0 60.4938 0.683546 60.152 1.57216L39.9874 52.3596Z",
    fill: "#04C37E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9933 52.3596C16.6515 53.2482 17.13 53.9318 18.087 53.9318H35.244C36.2009 53.9318 37.1579 53.1799 37.4313 52.2913L57.5276 1.64051C57.801 0.7519 57.2541 0 56.3655 0H39.482C38.525 0 37.4997 0.683546 37.1579 1.57216L16.9933 52.3596Z",
    fill: "#04C37E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b3516dddb4f332ee39dfb0f054f2f860.svg";
export { ForwardRef as ReactComponent };